import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function  VectorStores() {

    return (
        <div>


            <DHeader>Vector Stores</DHeader>

            <DText>
            Vector Stores are the nodes that are used to store and retrieve vectors.
            </DText>

            <DHeader className='h4'>Faiss</DHeader>

            <DText>
             Faiss is a vector store that is used to store and retrieve vectors.
            </DText>
       

           
            
            {/* <DCode>
                {`python QuickStart.py`}
            </DCode> */}
       
        </div>
    )
}